import * as models from './models/v2';

export function CanAmount(paymentOptionTypeID?: number) {
    return paymentOptionTypeID === models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_BALANCE ||
        paymentOptionTypeID === models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_CREDIT ||
        paymentOptionTypeID === models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_BANK;
}
